import React from "react";
import Flex from "../components/blocks/Flex";
import NavBar from "../components/NavBar";

export default () =>
  <div>
    <NavBar color="dark" />
    <Flex direction="column" justify="center" style={{ height: "80vh" }}>
      <h1 style={{ paddingBottom: ".75rem" }}>Page not found</h1>
      <p>You just hit a route that doesn't exist.</p>
    </Flex>
  </div>;



// WEBPACK FOOTER //
// ./src/pages/404.js